'use client'

import { useState } from "react"
import DropdownPresentation from "./Presentation-Dropdown"
import Link from "next/link";
import Image from "next/image";

/**
 * Retourne la bannière de la page d'acceuil
 * @param {object} parametter - Paramètre du composant.
 * @param {"fr"|"en"|"nl"} parametter.lang - Langue du site web.
 * @param {object} parametter.data - Donnée de la page d'acceuil. 
 * @param {object} parametter.links - Liste des liens du site web.
 * @param {object} parametter.locale - Dictionnaire de la page d'acceuil du site web.
 * @param {string} parametter.rma - Ecole Royale Militaire traduit dans la langue du site.
 * @returns 
 */
export default function Presentation({locale,lang,links,rma,data}) {


    const studentText = <div className="lg:col-span-6 col-span-12 content-between p-8 sm:p-0 sm:mt-8 mt-0 text-left">
                            <p className="text lora sub md:text-black text-[#000066] "> {data.welcomText[lang].welcome}</p>
                            <h2 className="mb-4 Primary font-bold text heading-3 font-bold">{rma}</h2>
                            <p className="mb-6 font-bold text paragraph">{data.welcomText[lang].text}</p>
                            <h2 className="mb-2 Student font-bold text heading-4">{locale.Dropdowns.Student.StudentTrainee}</h2>
                            <p className="font-[300]  mb-2 text paragraph">{data.profilText.student[lang].text}</p>
                            <Link href={data.profilText.student[lang].buttonLink}>
                            <button className="my-4 button-Student large-button">
                                    {locale.Dropdowns.Student.button}
                            </button>
                            </Link>

                        </div>

    const researchersText = <div className="lg:col-span-6 col-span-12 content-between p-8 sm:p-0 sm:mt-8 mt-0 text-left">
                            <p className="text md:text-black text-[#000066] lora sub"> {data.welcomText[lang].welcome}</p>
                            <h2 className="mb-4 Primary font-bold text heading-3 font-bold">{rma}</h2>

                                <p className="mb-6 font-bold text paragraph">{data.welcomText[lang].text}</p>
                                <h2 className="mb-2 Researchers font-bold text heading-4">{locale.Dropdowns.Researchers.Researchers}</h2>
                                <p className="mb-2 font-[300] text paragraph">{data.profilText.researcher[lang].text}</p>
                                <Link href={data.profilText.researcher[lang].buttonLink}>
                                    <button className="my-4 button-Researchers large-button">
                                    {locale.Dropdowns.Researchers.button}
                                    </button>
                                </Link>
                            </div>

const youngText = <div className="lg:col-span-6 col-span-12 content-between p-8 sm:p-0 sm:mt-8 mt-0 text-left">
                            <p className="text lora sub md:text-black text-[#000066]"> {data.welcomText[lang].welcome}</p>
                            <h2 className="mb-4 Primary font-bold text heading-3 font-bold">{rma}</h2>
                            <p className="mb-6 font-bold text paragraph">{data.welcomText[lang].text}</p>
                            <h2 className="mb-2 Young font-bold text heading-4">{locale.Dropdowns.CandidatOfficer.CandidatOfficer}</h2>
                            <p className="mb-2 font-[300] text paragraph">{data.profilText.futureStudent[lang].text}</p>
                            <Link href={data.profilText.futureStudent[lang].buttonLink}>
                                <button className=" my-4 button-Young large-button">
                                    {locale.Dropdowns.CandidatOfficer.button}                            
                                </button>
                            </Link>
                            
                        </div>

const alumniText = <div className="lg:col-span-6 col-span-12 content-between p-8 sm:p-0 sm:mt-8 mt-0 text-left">
                            <p className="text lora sub"> {data.welcomText[lang].welcome}</p>
                            <h2 className="mb-4 Primary font-bold text heading-3 font-bold">Royal Military Academy</h2>
                            <p className="mb-6 font-bold text paragraph">{data.welcomText[lang].text}</p>
                            <h2 className="mb-2 Alumni font-bold text heading-4">{locale.Dropdowns.Alumni.Alumni}</h2>
                            <p className="mb-2 font-[300] text paragraph">{data.profilText.alumni[lang].text}</p>
                            <Link href={data.profilText.alumni[lang].buttonLink} target="_blank">
                                <button className="my-4 button-Alumni large-button">
                                {locale.Dropdowns.Alumni.button}
                                </button>
                            </Link>
                            
                        </div>

const [youngHover,setYoungHover]=useState("opacity-100 border-4")
const [researchersHover,setResearchersHover]=useState("")
const [studentHover,setStudentHover]=useState("")
const [alumniHover,setAlumniHover]=useState("")

const [youngOpacity,setYoungOpacity]=useState("opacity-100")
const [researchersOpacity,setResearchersOpacity]=useState("opacity-50")
const [studentOpacity,setStudentOpacity]=useState("opacity-50")
const [alumniOpacity,setAlumniOpacity]=useState("opacity-50")

const [focus,setFocus]=useState({active:false,profil:""})

const [text,setText]=useState(youngText);

/**
 * Indique visuellement le persona séléctionné
 * @param {"young"|"researchers"|"student"|"alumni"} persona - Persona séléctionné 
 */
function selectPersona(persona){
    if(!focus.active){
        setYoungHover("");
        setYoungOpacity("opacity-50");

        setResearchersHover("");
        setResearchersOpacity("opacity-50");

        setStudentHover("");
        setStudentOpacity("opacity-50");

        setAlumniHover("");
        setAlumniOpacity("opacity-50");

        switch(persona){
            case "young": setText(youngText);setYoungOpacity("opacity-100");setYoungHover("border-4");break;
            case "researchers": setText(researchersText);setResearchersOpacity("opacity-100");setResearchersHover("border-4");break;
            case "student": setText(studentText);setStudentOpacity("opacity-100");setStudentHover("border-4");break;
            case "alumni": setText(alumniText);setAlumniOpacity("opacity-100");setAlumniHover("border-4");break;
        }
    }
}

/**
 * Cette fonction gère la manière dont un persona est ciblé.
 * @param {Event} e - Objet 'Event' de l'élément html 
 */
const handleFocus = (e) => {
    const name = e.target.name
    setYoungHover("");
    setYoungOpacity("opacity-50");

    setResearchersHover("");
    setResearchersOpacity("opacity-50");

    setStudentHover("");
    setStudentOpacity("opacity-50");

    setAlumniHover("");
    setAlumniOpacity("opacity-50");

    if(!focus.active ||focus.profil!==name){
        setFocus({active:true,profil:name})
        switch (name) {
            case "futur-student":
            setYoungHover("border-8")
            setYoungOpacity("opacity-100");
            setText(youngText);
            break;

            case "student":
            setStudentHover("border-8")
            setStudentOpacity("opacity-100")
            setText(studentText);

            break;

            case "researcher":
            setResearchersHover("border-8")
            setResearchersOpacity("opacity-100")
            setText(researchersText);
            break;

            case "alumni":
            setAlumniHover("border-8")
            setAlumniOpacity("opacity-100")
            setText(alumniText)
            break;
        }
    }
    else setFocus({active:false,profil:""})
}


    return(
        <div className="relative">
            <div className="lg:absolute sm:static absolute grid lg:gap-6 gap-3 lg:-top-28 -top-16 z-10  lg:p-20 p-8 sm:grid-cols-2 lg:grid-cols-12 grid-cols-1 inset-x-0 flex transition-all">
                <DropdownPresentation id={"Young"} typeMenu={"Young"} title={locale.Dropdowns.CandidatOfficer.CandidatOfficer} menu={[locale.Dropdowns.CandidatOfficer.Admission,locale.Dropdowns.CandidatOfficer.Formation,locale.Dropdowns.CandidatOfficer.InformationsPratiques,"FAQ"]} buttonText={locale.Dropdowns.MoreInfo} links={[links.Admission,links.Formation,links.InfoPratique,links.FAQ]} buttonLink={"/"} isBlank={[false,false,false,false,false]} isBlankButton={false}/>              
                <DropdownPresentation id={"Student"} typeMenu={"Student"} title={locale.Dropdowns.Student.StudentTrainee} menu={[locale.Dropdowns.Student.erasmus]} buttonText={locale.Dropdowns.MoreInfo} links={[links.Erasmus]} buttonLink={"/"} isBlank={[false]} isBlankButton={false}/>
                <DropdownPresentation id={"Researchers"} typeMenu={"Researchers"} title={locale.Dropdowns.Researchers.Researchers} menu={[locale.Dropdowns.Researchers.Laboratoire,locale.Dropdowns.Researchers.unitéDeRecherche,locale.Dropdowns.Researchers.Bibliothèque,locale.Dropdowns.Researchers.PhD]} buttonText={locale.Dropdowns.MoreInfo} links={[links.Laboratoires,links.UniteRecherche,links.Bibli,links.PhD]} buttonLink={"/"} isBlank={[true,true,true,true]} isBlankButton={false}/>
                <DropdownPresentation id={"Alumni"} typeMenu={"Alumni"} title={locale.Dropdowns.Alumni.Alumni} menu={[locale.Dropdowns.Alumni.home,locale.Dropdowns.Alumni.news,locale.Dropdowns.Alumni.Associations,locale.Dropdowns.Alumni.Calendar]} buttonText={locale.Dropdowns.MoreInfo} links={[`https://alumni.rma.ac.be/${lang}/`,`https://alumni.rma.ac.be/${lang}/actualites`,`https://alumni.rma.ac.be/${lang}/groups/categories/20`,`https://alumni.rma.ac.be/${lang}/agenda`]} buttonLink={`https://alumni.rma.ac.be/${lang}/`} isBlank={[true,true,true,true]} isBlankButton={true}/>
            </div>
            <div className="grid grid-cols-12 gap-4 flex items-center title-bloc grid-cols-1 Presentation lg:px-20 sm:px-8 lg:pt-32 lg:pb-0 text-center md:text-left">
                <div className="lg:col-span-6 col-span-12 overflow-x-auto " >
                    <div className="lg:block hidden flex md:justify-start justify-center items-center md:py-0 py-2 w-[1000px] lg:w-full">
                        <div className="flex mb-7">
                            <Image name="futur-student" width={300} height={300} alt={"Nouvel étudiant de l'Ecole Royale Militaire"} src={data.profil.futureStudent} className={"transition-all ease-in-out cursor-pointer hover:opacity-100 hover:border-8  rounded-full md:w-[40%] w-auto  Yong-Profils md:col-span-3 inset-x-0 origin-bottom-right mr-7 "+ youngHover+" "+youngOpacity} onMouseEnter={()=>selectPersona("young")} onClick={handleFocus} />
                            <Image name="student" width={300} height={300} alt={"Elève ayant fini sa PIM et commançant sa nouvel vie d'étudiant à l'Ecole Royale Militaire"} src={data.profil.student} className={"transition-all ease-in-out cursor-pointer hover:opacity-100 hover:border-8 rounded-full md:w-[40%] w-auto Student-Profils md:col-span-3 inset-x-0 origin-top-right  "+studentHover+" "+studentOpacity} onMouseEnter={()=>selectPersona("student")} onClick={handleFocus}/>
                        </div>
                        <div className="flex">
                            <Image name="researcher" width={300} height={300} alt={"Militaire dans un laboratoire"} src={data.profil.researcher} className={"transition-all ease-in-out cursor-pointer  hover:opacity-100 hover:border-8 rounded-full md:w-[40%] w-auto Researchers-Profils md:col-span-3 inset-x-0 origin-bottom-left mr-7  "+ researchersHover+" "+researchersOpacity} onMouseEnter={()=>selectPersona("researchers")} onClick={handleFocus}  />
                            <Image name="alumni" width={300} height={300} alt={"membre d'alumni"}  src={data.profil.alumni} className={"transition-all ease-in-out cursor-pointer hover:opacity-100 hover:border-8 rounded-full md:w-[40%] w-auto Alumini-Profils md:col-span-3 inset-x-0 origin-top-left  "+alumniHover+" "+alumniOpacity} onMouseEnter={()=>selectPersona("alumni")} onClick={handleFocus} />
                        </div>
                    </div>
                    <div className="lg:hidden sm:mt-0 mt-[350px] flex lg:justify-start justify-center items-center lg:py-0 py-2 w-[1000px] lg:w-full">
                            <Image name="futur-student" width={300} height={300} alt={"Nouvel étudiant de l'Ecole Royale Militaire"} src={data.profil.futureStudent} className={"transition-all ease-in-out cursor-pointer hover:opacity-100 hover:border-8  rounded-full md:w-[40%] w-auto  Yong-Profils md:col-span-3 inset-x-0 origin-bottom-right mr-7 "+ youngHover+" "+youngOpacity} onMouseEnter={()=>selectPersona("young")} onClick={handleFocus} />
                            <Image name="student" width={300} height={300} alt={"Elève ayant fini sa PIM et commançant sa nouvel vie d'étudiant à l'Ecole Royale Militaire"} src={data.profil.student} className={"transition-all ease-in-out cursor-pointer hover:opacity-100 hover:border-8 rounded-full md:w-[40%] w-auto Student-Profils md:col-span-3 inset-x-0 origin-top-right mr-7 "+studentHover+" "+studentOpacity} onMouseEnter={()=>selectPersona("student")} onClick={handleFocus}/>
                            <Image name="researcher" width={300} height={300} alt={"Militaire dans un laboratoire"} src={data.profil.researcher} className={"transition-all ease-in-out cursor-pointer  hover:opacity-100 hover:border-8 rounded-full md:w-[40%] w-auto Researchers-Profils md:col-span-3 inset-x-0 origin-bottom-left mr-7  "+ researchersHover+" "+researchersOpacity} onMouseEnter={()=>selectPersona("researchers")} onClick={handleFocus}  />
                            <Image name="alumni" width={300} height={300} alt={"membre d'alumni"}  src={data.profil.alumni} className={"transition-all ease-in-out cursor-pointer hover:opacity-100 hover:border-8 rounded-full md:w-[40%] w-auto Alumini-Profils md:col-span-3 inset-x-0 origin-top-left  "+alumniHover+" "+alumniOpacity} onMouseEnter={()=>selectPersona("alumni")} onClick={handleFocus} />

                    </div>
                </div>
                {text}
                
            </div>
        </div>
    )
}